import { motion } from "framer-motion";
import { CHAPTERS, CORE_VALUES } from "@/data/site";

export default function Chapters() {
  return (
    <section id="about" className="relative py-32 md:py-48" data-testid="chapters">
      <div className="container-mit">
        <div className="flex items-baseline justify-between mb-20">
          <p className="text-[11px] tracking-[0.4em] text-[#A4801C]">— MANIFESTO</p>
          <p className="text-[11px] tracking-[0.3em] text-[#0A0A14]/50">CHAPTERS 01 / 02 / 03</p>
        </div>

        <div className="flex flex-col gap-32">
          {CHAPTERS.map((c, i) => (
            <ChapterRow key={c.number} c={c} flip={i % 2 === 1} />
          ))}
        </div>

        {/* Core values */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="mt-32 pt-16 border-t border-[#0A0A14]/12"
        >
          <p className="text-[11px] tracking-[0.4em] text-[#A4801C] mb-8">CORE VALUES</p>
          <div className="flex flex-wrap gap-x-12 gap-y-4">
            {CORE_VALUES.map((v, i) => (
              <span key={v} className="font-display text-4xl md:text-5xl text-[#0A0A14]/85">
                {v}
                {i < CORE_VALUES.length - 1 && <span className="text-[#A4801C] mx-4">·</span>}
              </span>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}

function ChapterRow({ c, flip }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, ease: [0.22, 0.62, 0.24, 1] }}
      className={`grid grid-cols-1 md:grid-cols-12 gap-8 items-start ${flip ? "md:text-right" : ""}`}
      data-testid={`chapter-${c.number}`}
    >
      <div className={`md:col-span-3 ${flip ? "md:order-last" : ""}`}>
        <div className="numeral-outline text-[120px] md:text-[160px] leading-none">{c.number}</div>
        <p className="text-[11px] tracking-[0.4em] text-[#A4801C] mt-4">{c.kicker.toUpperCase()}</p>
      </div>
      <div className="md:col-span-9">
        <h3 className="font-display font-light text-4xl md:text-6xl leading-[1.02] text-[#0A0A14] mb-8 max-w-3xl">
          {c.title}
        </h3>
        <p className="text-[#0A0A14]/70 text-lg leading-relaxed max-w-2xl">{c.body}</p>
      </div>
    </motion.div>
  );
}
